<template>
  <v-container class="my-12 px-12">
    <!-- Título -->
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center pb-0">
        <h1 class="display-1 font-weight-bold">Requisitos para activar tu servicio de cambio de divisas</h1>
        <p class="subtitle-1 grey--text">
          Revisa la lista de información necesaria antes de continuar con tu registro en el servicio de cambio de divisas.
        </p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
        <v-btn color="primary" @click="mailTo()" large rounded>
          Contact
          <v-icon right>mdi-mailbox</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="pa-6" elevation="8" color="#F5F5F5" style="border-radius: 12px;">
          <div class="d-flex align-center mb-4">
            <v-img src="@/assets/images/Flags_usa.svg" contain max-width="32" class="mr-2"></v-img>
            <h3 class="font-weight-bold mb-0" style="font-family: 'montserrat-bold'; ">Empresa Americana</h3>
          </div>
          <ul class="requirements-list">
            <li>Incorporation document of the company</li>
            <li>Supporting Tax ID documentation (EIN or W9)</li>
            <li>Attestation of beneficial ownership</li>
            <li>Official government ID of the Legal Representative (can also be a Passport)</li>
            <li>Bank statement (less than 2 months old)</li>
            <li>Official government ID of all stakeholders with 25% (or more) of the shares of the company</li>
            <li>Proof of Address (less than 2 months old) of each stakeholder with 25% (or more) of the shares of the company</li>
            <li>3 invoices (less than 2 months old) of any customer or supplier</li>
            <li>Company’s website or social media</li>
            <li>Company’s telephone</li>
          </ul>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="pa-6" elevation="8" color="#F5F5F5" style="border-radius: 12px;">
          <div class="d-flex align-center mb-4">
            <v-img src="@/assets/images/Flags_mex.svg" contain max-width="32" class="mr-2"></v-img>
            <h3 class="font-weight-bold mb-0" style="font-family: 'montserrat-bold';">Empresa Mexicana</h3>
          </div>
          <ul class="requirements-list">
            <li>Acta constitutiva</li>
            <li>Identificación vigente de representante legal</li>
            <li>Comprobante de domicilio de la empresa</li>
            <li>Poderes del Representante Legal</li>
            <li>Registro Público de Comercio (RPC)</li>
            <li>Comprobante del domicilio de los accionistas con el 25% o más de las acciones</li>
            <li>Constancia de situación Fiscal</li>
            <li>Soporte de Naturaleza Empresarial en el Extranjero</li>
            <li>Website o red social de la empresa</li>
            <li>Comprobante de generación de certificado digital (FIEL)</li>
            <li>Estado de cuenta bancario a nombre de la empresa</li>
            <li>Teléfono de contacto de la empresa</li>
            <li>Número de cuenta CLABE para afiliar cuenta</li>
            <li>Identificación vigente de los accionistas con el 25% o más de las acciones</li>
          </ul>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CurrencyExchangeRequirements',
  methods: {
    mailTo() {
      window.location.href = 'mailto: compliance@fresherpay.com';
    }
  }
};
</script>

<style scoped>
.requirements-list {
  padding-left: 1rem;
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  font-family: 'montserrat-semibold';
}
.requirements-list li {
  margin-bottom: 6px;
}
</style>
